export default __webpack_public_path__ + "static/media/2023-GHSI-Annual Stockholders Meeting Minutes.ed3cda9b.pdf";